import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';

registerFragment('ay-pcr-recipient-helper', (fragEl, config, meta) => { });

if (import.meta.hot) {
    import.meta.hot.accept();
}
